import {
  defineStyleConfig,
  StyleThemingProps,
  useStyleConfig,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { getName } from '~/utils/objectUtils'

const {
  Background: {
    SecondaryNav: { Default: SecondaryNavBackgroundColor },
  },
} = themeColorSectionKeys.defaults

export const HeaderStyle = defineStyleConfig({
  baseStyle: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexShrink: 0,
    width: 'full',
    minWidth: 0,
    height: '4.5rem',
    backgroundColor: SecondaryNavBackgroundColor,
  },
})

export const useHeaderStyle = (props?: StyleThemingProps) => {
  return useStyleConfig(getName({ HeaderStyle }), props)
}
